import {
    Alert,
    Button,
    Card,
    CardActions,
    CardContent,
    FormControl,
    Grid,
    Table,
    TableBody,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography,
} from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setShowVerifyClientSecretForm } from "../../../redux/botManagement/botManagementSlice";
import { UpdateClientSecretThunk, VerifyClientSecretThunk } from "../../../redux/botManagement/botManagementThunk";
import { apiGatewayAxiosInstance } from "../../../utils/axios";
import AlertMessageComponent from "../../components/AlertMessageComponent";
import { Description } from "@mui/icons-material";
import StyledTableCell from "../../components/StyledTableCell";
import FetchingSpinner from "../../components/FetchingSpinner";
import StyledTableRow from "../../components/StyledTableRow";
import NoRecords from "../../components/NoRecords";
import RefreshButton from "../../../utils/refreshButton";

export default function VerifyClientSecret({ setOperationStatus }) {
    const state = useSelector(state => state.botManagementSlice);
    const [botDetails, setBotDetails] = useState(null);
    const [errorResponse, setErrorResponse] = useState("");
    const [getBotDetailsLoading, setGetBotDetailsLoading] = useState(false);
    const [isLoding, setIsLoding] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = React.useState(10);
    const dispatch = useDispatch();
    const [reload, setReload] = useState(false);
    const [isDataPresent, setIsDataPresent] = useState(false);

    const onClickCancelButton = () => {
        dispatch(setShowVerifyClientSecretForm({ status: false, botId: "" }));
    };

    const formik = useFormik({
        initialValues: {
            botId: state.controls.showVerifyClientSecretForm.botId,
            rbmClientId: "",
            rbmClientSecret: "",
            description: "",
            previousClientIds: [],
        },
        // validationSchema: Yup.object().shape({
        //   rbmClientId: Yup.string()
        //     .required("Client Id is required!")
        //   // .min(12, "Max 12 characters can be used")
        //   // .max(255, "Max 225 characters can be used")
        //   ,
        //   rbmClientSecret: Yup.string()
        //     .required("Client Secret is required!")
        //   // .min(12, "Max 12 characters can be used")
        //   // .max(255, "Max 20 characters can be used")
        //   ,
        // }),

        onSubmit: async (values, { setErrors, setStatus, setSubmitting, resetForm }) => {
            try {
                setIsLoding(true);
                const validate = await validateDatingTemplate();
                if (validate) {
                    const dataToSend = {
                        botId: values.botId,
                        config: {
                            ...botDetails.config,
                            rbmClientId: values.rbmClientId.trim(),
                            rbmClientSecret: values.rbmClientSecret.trim(),
                        },
                    };
                    await dispatch(
                        VerifyClientSecretThunk({
                            data: dataToSend,
                        }),
                    )
                        .unwrap()
                        .then(() => {
                            setOperationStatus({
                                message: "Client Secret Added.",
                                success: true,
                                failed: false,
                            });
                        });
                }
                setIsLoding(false);
                dispatch(setShowVerifyClientSecretForm({ status: false, botId: "" }));
            } catch (error) {
                const message = formik.errors.message || "Something went wrong";
                setStatus({ success: false });
                setErrors({ submit: message });
                setSubmitting(false);
                setIsLoding(false);
            }
        },
    });
    const onClickUpdateButton = async () => {
        try {
            setIsLoding(true);
            const isValid = await validateDatingTemplate();
            if (!isValid) return;

            const dataToSend = {
                botId: formik.values.botId,
                description: formik.values.description,
                config: {
                    ...botDetails.config,
                    rbmClientId: formik.values.rbmClientId.trim(),
                    rbmClientSecret: formik.values.rbmClientSecret.trim(),
                },
            };

            const result = await dispatch(UpdateClientSecretThunk({ data: dataToSend })).unwrap();

            setOperationStatus({
                message: "Client Secret Updated.",
                success: true,
                failed: false,
            });

            dispatch(setShowVerifyClientSecretForm({ status: false, botId: "" }));
        } catch (error) {
            setErrorResponse(error?.message || "Something went wrong");
        } finally {
            setIsLoding(false);
        }
    };

    useEffect(() => {
        getBotDetails();
    }, [reload]);

    const getBotDetails = async () => {
        try {
            setGetBotDetailsLoading(true);
            const response = await apiGatewayAxiosInstance.get(`/bot_management/bot/get-bot-details`, {
                headers: {
                    "Content-Type": "application/json",
                    botId: state.controls.showVerifyClientSecretForm.botId,
                },
            });
            if (response.status === 200) {
                setBotDetails(response.data.botDetails);
                if (response.data.botDetails.config?.rbmClientId) {
                    formik.setFieldValue("rbmClientId", response.data.botDetails.config?.rbmClientId);
                    if (response.data.botDetails.config?.rbmClientId) {
                        setIsDataPresent(true);
                    }
                }
                if (response.data.botDetails.config?.rbmClientSecret) {
                    formik.setFieldValue("rbmClientSecret", response.data.botDetails.config?.rbmClientSecret);
                }
                if (response.data.botDetails.config?.previousClientIds?.length > 0) {
                    formik.setFieldValue("previousClientIds", response.data.botDetails.config.previousClientIds);
                }
                setGetBotDetailsLoading(false);
            } else {
                throw new Error(response);
            }
        } catch (error) {
            let errorMessage = "Failed to get bot details.";

            if (error.response) {
                errorMessage = (error.response.data && error.response.data.message) ?? errorMessage;
            }
            setErrorResponse(errorMessage);
            setGetBotDetailsLoading(false);
        }
    };

    // const onClickOnSaveButton = () => {
    //   formik.handleSubmit();
    // };

    const validateDatingTemplate = async () => {
        // validateIfValueIsEmpty()
        let result = true;

        if (formik.values.rbmClientId.trim() === "") {
            result = false;
            formik.setFieldError("rbmClientId", `Client Id  is required`);
        }
        if (formik.values.rbmClientSecret.trim() === "") {
            result = false;
            formik.setFieldError("rbmClientSecret", `Client Secret  is required`);
        }

        return result;
    };

    const reloadList = () => {
        setReload(!reload);
    };

    return (
        <>
            {!isLoding ? (
                <form onSubmit={formik.handleSubmit}>
                    <Card>
                        <CardContent sx={{ padding: "10px" }}>
                            <Typography variant="h4" display={"flex"} gap={2}>
                                <b>Verify client secret for</b>
                                <b className="text-primary">{botDetails?.botName}</b>
                            </Typography>
                            <hr />
                            <Grid className="row mt-3" container>
                                <Grid item md={6}>
                                    <TextField
                                        name="rbmClientId"
                                        fullWidth
                                        label="Client ID"
                                        variant="outlined"
                                        onBlur={formik.handleBlur}
                                        error={Boolean(formik.errors.rbmClientId)}
                                        helperText={formik.errors.rbmClientId}
                                        value={formik.values.rbmClientId}
                                        onChange={formik.handleChange}
                                        inputProps={{ maxLength: 100 }}
                                    />
                                    <Grid sx={{ display: "flex", flexDirection: "row-reverse" }}>
                                        <Typography>{formik.values.rbmClientId.length}/100</Typography>
                                    </Grid>
                                </Grid>

                                <Grid md={6}>
                                    <TextField
                                        name="rbmClientSecret"
                                        fullWidth
                                        label="Client Secret"
                                        variant="outlined"
                                        onBlur={formik.handleBlur}
                                        error={Boolean(formik.errors.rbmClientSecret)}
                                        helperText={formik.errors.rbmClientSecret}
                                        value={formik.values.rbmClientSecret}
                                        onChange={formik.handleChange}
                                        inputProps={{ maxLength: 100 }}
                                    />
                                    <Grid sx={{ display: "flex", flexDirection: "row-reverse" }}>
                                        <Typography>{formik.values.rbmClientSecret.length}/100</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid>
                                {isDataPresent && (
                                    <FormControl sx={{ width: "48%" }}>
                                        <TextField
                                            name="description"
                                            fullWidth
                                            label="Description"
                                            variant="outlined"
                                            className="field-spacing"
                                            onBlur={formik.handleBlur}
                                            value={formik.values.description}
                                            onChange={formik.handleChange}
                                            inputProps={{ maxLength: 300 }}
                                        />
                                        <Grid sx={{ display: "flex", flexDirection: "row-reverse" }}>
                                            <Typography>{formik.values.description.length}/300</Typography>
                                        </Grid>
                                    </FormControl>
                                )}
                            </Grid>
                        </CardContent>
                        <CardActions sx={{ padding: "0px" }}>
                            <Grid display={"flex"}>
                                {isDataPresent ? (
                                    <Button variant="contained" onClick={onClickUpdateButton} className="m-2">
                                        Update
                                    </Button>
                                ) : (
                                    <Button
                                        variant="contained"
                                        type="submit"
                                        // onClick={onClickOnSaveButton}
                                        className="m-2"
                                    >
                                        Save
                                    </Button>
                                )}

                                <Button variant="contained" color="error" onClick={onClickCancelButton} className="m-2">
                                    Cancel
                                </Button>
                            </Grid>
                            <Grid>
                                {formik.values.previousClientIds.length > 0 && <RefreshButton loading={getBotDetailsLoading} onClick={reloadList} />}
                            </Grid>
                        </CardActions>
                        {getBotDetailsLoading ? (
                            <FetchingSpinner />
                        ) : formik.values.previousClientIds.length > 0 ? (
                            <TableContainer className="table-container" sx={{ maxHeight: "70vh", mt: 4, overflowY: "auto" }}>
                                <Table stickyHeader aria-label="scrollable table">
                                    <TableHead className="p-3 mb-2 row">
                                        <TableRow>
                                            <StyledTableCell className="col-1 tableHeaderFont" align="center">
                                                Sr No
                                            </StyledTableCell>
                                            <StyledTableCell className="col-2 tableHeaderFont" align="left">
                                                RbmClientId
                                            </StyledTableCell>

                                            <StyledTableCell className="col-2 tableHeaderFont" align="left">
                                                Updated By UserName
                                            </StyledTableCell>

                                            <StyledTableCell className="col-2 tableHeaderFont" align="left">
                                                Updated By UserRole
                                            </StyledTableCell>

                                            {/* <StyledTableCell className="col-2 tableHeaderFont" align="left">
                                                Description
                                            </StyledTableCell> */}

                                            <StyledTableCell className="col-2 tableHeaderFont" align="left">
                                                Updated At
                                            </StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {formik.values.previousClientIds?.map((previousClientdetail, index) => (
                                            <StyledTableRow key={index}>
                                                <StyledTableCell className="tableContentFont" align="center">
                                                    {index + 1}
                                                </StyledTableCell>

                                                <StyledTableCell className="tableContentFont" align="left">
                                                    {previousClientdetail.rbmClientId}
                                                </StyledTableCell>

                                                <StyledTableCell className="tableContentFont" align="left">
                                                    {previousClientdetail.updatedByUserName}
                                                </StyledTableCell>

                                                <StyledTableCell className="tableContentFont" align="left">
                                                    {previousClientdetail.updatedByRoleName}
                                                </StyledTableCell>

                                                {/* <StyledTableCell className="tableContentFont" align="left">
                                                    {previousClientdetail.description}
                                                </StyledTableCell> */}

                                                <StyledTableCell className="tableContentFont" align="left">
                                                    {new Date(previousClientdetail.updatedAt).toLocaleString()}
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        ) : (
                            <NoRecords />
                        )}
                    </Card>
                    {state.controls.verifyClientSecretErrorMessage && (
                        <Alert mt={2} mb={3} severity="error">
                            {state.controls.verifyClientSecretErrorMessage}
                        </Alert>
                    )}
                    <AlertMessageComponent
                        message={errorResponse}
                        fieldName={"errorResponse"}
                        handleClose={() => setErrorResponse("")}
                        show={Boolean(errorResponse)}
                    />
                </form>
            ) : (
                <FetchingSpinner />
            )}
        </>
    );
}
